const link = [
  { name: "home", path: "home" },
  { name: "about", path: "about" },
  { name: "document", path: "document" },
  { name: "project", path: "projects" },
  { name: "contact", path: "contact" },
];
export default link;
export const cycleLife = [
  "Increase revenue",
  "Cut down-costs",
  "Improve strategic decision making",
  "become data-driven business",
  "Advance costumer experience",
  "Predict costumer churn",
  "Mitigate business risks",
  "Forecast future trends",
  "Improve work efficiency",
  " Simplify data management",
];
